import React from "react";
import '../../App.css';
import Menu from "../Menu";

function MenuPage() {
    return (
        <>
            <Menu />
        </>
    )
}

export default MenuPage;